export default __webpack_public_path__ + "static/media/cart.94d8b0dc.svg";